const breakpoints = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 2000,
    xxxl: 3000
}
export default breakpoints;